export const SET_PROFILE_NAMES = 'SET_PROFILE_NAMES'